import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import MonthlyUtilizationWrapper from './MonthlyUtilization';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import IntermediateCareUnitWrapper from './IntermediateCareUnit';
import ValueWrapper from './Value';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Utilização Mensal',
    1: 'Utilização - Intermediária',
    2: 'Tipos de Internação',
    3: 'Valor - UTI'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <MonthlyUtilizationWrapper />;
        case 1:
            return <IntermediateCareUnitWrapper />;
        case 2:
            return (
                <ServicesWrapper
                    module={{
                        sectionTitle: 'do Tipo de Internamento'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.UTI_TYPE,
                        url: 'governanceroom/dashboard/sihsus/aih/utiTypes'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 3:
            return <ValueWrapper />;
        default:
            return null;
    }
};

export const UTI = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Utilização - UTI',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Utilização - Intermediária',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Tipos de Internação',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Valor - UTI',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};